__turbopack_context__.v({
  "endOfList": "new-recipes-stream-module__lO7AsG__endOfList",
  "error": "new-recipes-stream-module__lO7AsG__error",
  "footer": "new-recipes-stream-module__lO7AsG__footer",
  "grid": "new-recipes-stream-module__lO7AsG__grid",
  "srOnly": "new-recipes-stream-module__lO7AsG__srOnly",
});
